import {ref,computed, onMounted} from 'vue'
import {useStore} from 'vuex'

import MegaMenu from './SiteNavigationMegaMenu.vue'

export default {
    name: "SiteNavigationMegaMenu",
    components:{
        MegaMenu
    },
    setup(){
        const store = useStore()
        const menuData = computed(()=>store.getters['main/getMegaMenuData'])
        const spotData = computed(()=>store.state.main.mega_menu_data.spots)

        const hideMegaMenu = function(){
            store.dispatch('main/closeMegaMenu')
        }

        const hideMegaMenuOnresize = () => {
            if(window.innerWidth < 1001) hideMegaMenu()
        }

        onMounted(()=>{

            const isMobile = 768
            if (window.innerWidth > isMobile) {
                store.dispatch('main/windowOnresize',hideMegaMenuOnresize)
            }

            /**
             * Reason for this check:
             * There is currently a bug on Android devices, on which the window.onresize function, within the action
             * 'windowOnresize', will fire on mount, although no re-size had occured. This multi-function call causes issues for 
             * different boolean view states. 
             * 
             * There is no reason to hide megamenu on resize on mobile, as you can't resize the window on these devices anyway.
             */ 
        })

        return {
            hideMegaMenu,
            menuData,
            spotData
        }
    }
}